'use client';

import { useEffect } from 'react';
import { readThemeChoice, applyTheme } from '@/theme';

export default function ThemeGuard() {
  useEffect(() => {
    applyTheme(readThemeChoice());
  }, []);

  return null;
}
